import { ROUTE_NAMES } from "@root/constants";
import AuthLayout from "@root/layouts/AuthLayout";
import ForgotPasswordLayout from "@root/layouts/ForgotPasswordLayout";
import FreeLayout from "@root/layouts/FreeLayout";
import OpenLayout from "@root/layouts/OpenLayout";
import AllSetLayout from "@root/layouts/AllSetLayout";
import {
  CheckEmail,
  ForgotPassword,
  Login,
  ResetPassword,
  ResetSuccess,
  Signup,
  ContactUsScreen,
  PrivacyPolicy,
  TermsConditions,
  EmailVerification,
  AllSet,
  LetsStart,
} from "@root/pages";
import { MainChatContainer } from "@root/pages/dashboard/components/mainChat";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { CountryProvider } from "@root/context";
import { AdminLogin } from "@root/pages/auth/login/adminLogin";
import { SuperAdminLogin } from "@root/pages/auth/login/superAdminLogin";


export const publicRoutes = createBrowserRouter([
  {
    path: "/",

    element: (


      <CountryProvider>
        <AuthLayout />
      </CountryProvider>

    ),
    children: [
      {
        path: "*",
        element: <Navigate to="/" />,
      },
      {
        path: "/",
        element: <Login />,
      },
      {
        path: ROUTE_NAMES.LOGIN,
        element: <Login />,
      },
      {
        path: ROUTE_NAMES.SINGUP,
        element: <Signup />,
      },
      {
        path: ROUTE_NAMES.ADMIN_LOGIN,
        element: <AdminLogin />,
      },
      {
        path: ROUTE_NAMES.SUPER_ADMIN_LOGIN,
        element: <SuperAdminLogin />,
      },
      {
        path: ROUTE_NAMES.EMAIL_VERIFICATION,
        element: <EmailVerification />,
      },
    ],
  },

  {
    path: "/",
    element: <AllSetLayout />,
    children: [
      {
        path: ROUTE_NAMES.ALL_SET,
        element: <AllSet />,
      },
      {
        path: ROUTE_NAMES.LETS_START,
        element: <LetsStart />,
      },
    ],
  },
  {
    path: "/",
    element: <OpenLayout />,
    children: [
      {
        path: ROUTE_NAMES.SHARED_CHAT,
        element: <MainChatContainer />,
      },
      {
        path: ROUTE_NAMES.SHARED_THREAD,
        element: <MainChatContainer />,
      },
    ],
  },
  {
    path: "/",
    element: <ForgotPasswordLayout />,
    children: [
      {
        path: ROUTE_NAMES.FORGET_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: ROUTE_NAMES.RESET_PASSWORD,
        element: <ResetPassword />,
      },
      {
        path: ROUTE_NAMES.RESET_SUCCESS,
        element: <ResetSuccess />,
      },
      {
        path: ROUTE_NAMES.CHECK_YOUR_EMAIL,
        element: <CheckEmail />,
      },

      {
        path: ROUTE_NAMES.CONTACT,
        element: <ContactUsScreen />,
      },
    ],
  },
  {
    path: "/",
    element: <FreeLayout />,
    children: [
      {
        path: ROUTE_NAMES.PRIVACY_POLICY,
        element: <PrivacyPolicy />,
      },
      {
        path: ROUTE_NAMES.TERMS_CONDITION,
        element: <TermsConditions />,
      },
    ],
  },
]);
